// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import formrule from '@/utils/formRule';
import filter from './utils/filter';
import waterfall from 'vue-waterfall2';

import fModel from '@/components/fModel';
import emptypage from '@/components/emptypage';
import mixin from '@/utils/mixin';
Vue.use(waterfall);
Vue.mixin(mixin);
for (const key in filter) {
  Vue.filter(key, filter[key]);
  Vue.prototype[key] = filter[key];
}
Vue.component('fModel', fModel);
Vue.component('emptypage', emptypage);
Vue.use(ElementUI);
Vue.prototype.formrule = formrule;
Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js